import styled from 'styled-components';

export const StyledList = styled.ul`
  padding: 0 15px 0 15px;
  margin-top: 20px;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
  }
`;

export const StyledGridList = styled.ul`
  @media ${({ theme }) => theme.device.desktop} {
    display: flex;
    flex-wrap: wrap;
  }
`;
